import * as React from 'react'
import config from '../../utils/config';
import request from '../../utils/request';

interface IProps {
    lan ? : string;
    className ? : string;
    url ? : string;
    shopInfo ? : any;
}

interface IState {
    languageOpen: boolean;
    shopInfo: any;
    languageUrlCn: string;
    languageUrlEn: string;
}

const enPathList = [
    '/classify', '/offerlist', '/offer', '/storeintro', '/zx'
]

export default class Language extends React.Component < IProps, IState > {
    constructor(props: IProps) {
        super(props)
        let enUrl = ''
        let cnUrl = ''
        const inEnList = enPathList.some(v => window.location.pathname.indexOf(v) > -1)
        if (inEnList) {
            enUrl = window.location.origin.replace('.cn', '.en') + window.location.pathname.replace('/m', '')
            enUrl = enUrl.replace(/\/$/, '.html')
        } else {
            enUrl = window.location.origin.replace('.cn', '.en')
        }

        cnUrl = window.location.href.replace('.en', '.cn')

        if (config.isLocalDev) {
            enUrl = enUrl.replace('/m', '/m/en')
            cnUrl = cnUrl.replace('/m/en', '/m')
        }

        this.state = {
            languageOpen: false,
            shopInfo: this.props.shopInfo,
            languageUrlCn: cnUrl,
            languageUrlEn: enUrl
        }
    }

    public componentDidMount() {
        if (!this.state.shopInfo) {
            this.getShopInfo()
        }
    }

    public componentWillUnmount() {
        // 在组件卸载时，将 setState 重新定义为空函数
        this.setState = (state, callback) => {
            return;
        }
    }

    public render() {
        const { shopInfo } = this.state
        const { lan, url } = this.props;
        if (lan !== '1' || (shopInfo && shopInfo.is_cross_border === '2')) {
            return <div className={'selects ' + (this.props.className || '')}>
                <p>
                    <span onClick={this.toggleLanguage}></span>
                    <a href={url || (lan === '1' ? this.state.languageUrlEn : this.state.languageUrlCn)}>{lan === '1' ? 'English' : '中文'}</a>
                </p>
                {
                    this.state.languageOpen && <ul>
                        <li><a href={window.location.href} className="ignore" target="_self">{lan === '1' ? '中文' : 'English'}</a></li>
                    </ul>
                }
              </div>
        }
        return null

    }

    private getShopInfo() {
        const path: any = (window as any).shopId;
        const r = request({
            data: {
                shopDomain: path,
            },
            method: 'post',
            url: config.PHPAPI + 'api/wshop/shop/shop-info',
        })

        r.then(res => {
            if (res.error_code === 0) {
                this.setState({
                    shopInfo: res.data[0]
                })
            }
        })
    }

    private toggleLanguage = () => {
        this.setState(state => ({
            languageOpen: !state.languageOpen
        }))
    }
}


// WEBPACK FOOTER //
// ./src/components/Header/language.tsx